/**
 * Gets page_type and page_id from the analytics div rendered by the application.
 * This div is placed on the page by content UI and contains data attributes with page metadata.
 *
 * @returns {Object} Object with analyticsPageType and analyticsPageId properties
 */
export const getPageAnalytics = () => {
  const analyticsDiv = document.getElementById("analytics");

  if (!analyticsDiv) {
    return {};
  }

  const pageType = analyticsDiv.getAttribute("data-pagetype");
  const pageTitle = analyticsDiv.getAttribute("data-pagetitle");

  if (!pageType) {
    return {};
  }

  // Normalize page type to lowercase for consistent comparison
  const normalizedPageType = pageType.toLowerCase();

  // Homepage mapping
  if (normalizedPageType === "homepage") {
    return {
      analyticsPageType: "home page",
      analyticsPageId: "home page"
    };
  }

  // Floor page mapping - requires page title
  if (normalizedPageType === "floor page" && pageTitle) {
    return {
      analyticsPageType: "floor page",
      analyticsPageId: `floor page: ${pageTitle.toLowerCase()}`
    };
  }

  return {};
};
